import Filter from "features/view/components/Filters/Filter";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Autocomplete from "components/form/Autocomplete/Autocomplete";
import Select from "components/form/Select/Select";
import { useConfig } from "context/ConfigContext";
import { useQuery } from "hooks/useQuery";

const LocationSearch = () => {
  const config = useConfig();
  const location = useLocation();
  const history = useHistory();
  const query = useQuery();
  const [ coordinates, setCoordinates ] = useState(query.get('location[value]'));
  const [ description, setDescription ] = useState(query.get('location[description]'));
  const [ range, setRange ] = useState(query.get('location[distance][from]') || config.location.defaultRange);

  const handleRenderResult = (result, forSelection) => {
    return forSelection ? result.description_short || result.description : result.description;
  }

  const handleSelectResult = (result) => {
    const newCoordinates = result ? `${ result.lat },${ result.lng }` : null;
    const searchParams = new URLSearchParams(window.location.search);
    if (newCoordinates) {
      searchParams.set('location[value]', newCoordinates);
      searchParams.set('location[distance][from]', range);
      searchParams.set('location[description]', result.description_short);
      searchParams.delete('page');
    } else {
      searchParams.delete('location[value]');
      searchParams.delete('location[distance][from]');
      searchParams.delete('location[description]');
    }

    setCoordinates(newCoordinates);

    history.push('?' + searchParams.toString());
  }

  useEffect(
    () => {
      if (range && range !== config.location.defaultRange) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('page');
        searchParams.set('location[distance][from]', range);
        history.push('?' + searchParams.toString());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ range ]
  );

  useEffect(
    () => {
      const searchParams = new URLSearchParams(window.location.search);
      const urlDescription = searchParams.get('location[description]');
      if (urlDescription) {
        setDescription(urlDescription);
      }
      const urlRange = searchParams.get('location[distance][from]');
      if (urlRange && urlRange !== config.location.defaultRange) {
        setRange(urlRange);
      }
      const urlCoordinates = searchParams.get('location[distance][value]');
      if (urlCoordinates) {
        setCoordinates(urlCoordinates);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ location ]);

  const rangeOptions = [
    {
      id: 999,
      value: 'Alle afstanden',
    },
    {
      id: 5,
      value: 'Tot 5 km',
    },
    {
      id: 10,
      value: 'Tot 10 km',
    },
    {
      id: 25,
      value: 'Tot 25 km',
    },
    {
      id: 50,
      value: 'Tot 50 km',
    },
    {
      id: 100,
      value: 'Tot 100 km',
    },
  ];

  return (
    <Filter title="Afstand">
      <Autocomplete endpoint={ `rest/geocode` }
                    value={ description && { description: description } }
                    placeholder={ `Zoek op postcode of plaats` }
                    onRenderResult={ handleRenderResult }
                    onSelect={ handleSelectResult }/>
      {
        coordinates &&
        <Select value={ range }
                items={ rangeOptions }
                onChange={ setRange }/>
      }
    </Filter>
  )
}

export default LocationSearch;
